import React from 'react';
import Panel from 'react-bootstrap/lib/Panel';

import {
  faUserCircle,
  faAddressCard,
} from '@fortawesome/free-regular-svg-icons';

import {
  faPencilAlt,
  faDollarSign,
  faLock,
  faCog,
  faPlusCircle,
} from '@fortawesome/free-solid-svg-icons';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import Link from '../../../components/Link';
import Question from '../../../components/Help/Questions/Question';

class TheBasicsSection extends React.Component {
  render() {
    return (
      <React.Fragment>
        <Panel>
          <Panel.Heading>A Quick Introduction</Panel.Heading>
          <Panel.Body>
            <Question
              answer={
                <div>
                  Shadower is an online platform that helps amateurs find
                  experts to shadow in real life.
                </div>
              }
              question="What is Shadower?"
            />

            <Question
              answer={
                <div>
                  <p>
                    Our mission is to reimagine how education works in an age
                    when experience and connections matter most. Our goal at
                    Shadower is to create a community of learners and
                    instructors free from the barriers of traditional education.
                    We aim to help those unable to pursue a full-time education
                    or internship, as well as those who thirst for a deeper
                    level of knowledge. We believe in the importance of
                    connecting students eager to grow with mentors excited to
                    instruct. We believe that every local community has
                    boundless talent waiting to be shared and aim to make the
                    process of sharing that knowledge as simple, effective and
                    affordable as possible.
                  </p>

                  <br/>

                  <p>
                    At Shadower, we believe that knowledge is just as important
                    as connecting with others. We seek to build relationships,
                    to help artists grow, to provide a path forward for learners
                    and to give opportunities to students and non-students
                    alike. We want experts and professionals to be able to share
                    their knowledge with a wider audience and receive fair
                    compensation for sharing their expertise, time and energy.
                  </p>
                </div>
              }
              question="Our mission"
            />

            <Question
              answer={
                <div>
                  Textbooks and online tutorials, whether paid or free, can only
                  teach you so much. What sets amateurs apart from experts is
                  real-world knowledge and hands-on experience. But acquiring
                  that knowledge and experience can be difficult without college
                  internships, formal education or connections in the industry.
                  Shadower aims to bridge that gap and make education
                  accessible, effective and affordable regardless of your
                  background. Through Shadower, you can receive immediate
                  feedback, get hands-on training and, most importantly, make
                  important real-world connections in the industry.
                </div>
              }
              question="Why should I use Shadower?"
            />

            <Question
              answer={
                <div>
                  Shadower is completely free to sign up and use. Experts charge
                  a fee to shadow them.
                </div>
              }
              question="How much does it cost to use Shadower?"
            />

            <Question
              answer={
                <div>
                  Everyone is welcome to use Shadower to explore new hobbies,
                  deepen a skillset or make professional connections. However,
                  our target demographics mainly include:
                  <ul>
                    <li>High School Students</li>
                    <ul>
                      <li>
                        Determine the right career path for you before college
                      </li>
                    </ul>
                    <li>College Students</li>
                    <ul>
                      <li>
                        Specialize your skillset without an internship and make
                        connections
                      </li>
                    </ul>
                    <li>Hobbyists</li>
                    <ul>
                      <li>Discover new skills and hobbies</li>
                    </ul>
                    <li>Amateurs</li>
                    <ul>
                      <li>
                        Deepen your knowledge and step into the professional
                        sphere
                      </li>
                    </ul>
                    <li>Experts</li>
                    <ul>
                      <li>Share your passions and earn supplemental income</li>
                    </ul>
                  </ul>
                  <br/>
                  <p>
                    Learn more about how Shadower can specifically{' '}
                    <Link to="/demographics">help you</Link>.
                  </p>
                </div>
              }
              question="Is Shadower right for me?"
            />

            <Question
              answer={
                <div>
                  <p>
                    Listed below are the current categories available for
                    experts to create a shadowing profile.
                  </p>
                  <ul>
                    <li>
                      <Link to="/shadowings/areas-of-expertise/art">Art</Link>
                    </li>
                    <ul>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/art/glasswork">
                          Glasswork
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/art/graphic-art">
                          Graphic Art
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/art/metalwork">
                          Metalwork
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/art/multimedia-art">
                          Multimedia Art
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/art/sculpture">
                          Sculpture
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/art/woodcraft">
                          Woodcraft
                        </Link>
                      </li>
                    </ul>

                    <li>
                      <Link to="/shadowings/areas-of-expertise/business">
                        Business
                      </Link>
                    </li>
                    <ul>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/business/entrepreneurship">
                          entrepreneurship
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/business/finance">
                          finance
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/business/investing">
                          investing
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/business/management">
                          management
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/business/marketing">
                          marketing
                        </Link>
                      </li>
                    </ul>

                    <li>
                      <Link to="/shadowings/areas-of-expertise/communication">
                        Communication
                      </Link>
                    </li>
                    <ul>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/communication/fiction-writing">
                          Fiction Writing
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/communication/journalism">
                          Journalism
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/communication/nonfiction-writing">
                          Nonfiction Writing
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/communication/public-relations">
                          Public Relations
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/communication/radio-broadcasting">
                          Radio Broadcasting
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/communication/television-broadcasting">
                          Television Broadcasting
                        </Link>
                      </li>
                    </ul>

                    <li>
                      <Link to="/shadowings/areas-of-expertise/design">
                        Design
                      </Link>
                    </li>
                    <ul>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/design/architectural-design">
                          Architectural Design
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/design/computer-aided-design">
                          Computer-Aided Design
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/design/graphic-design">
                          Graphic Design
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/design/interior-design">
                          Interior Design
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/design/product-design">
                          Product Design
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/design/ui-ux-design">
                          UI/UX Design
                        </Link>
                      </li>
                    </ul>

                    <li>
                      <Link to="/shadowings/areas-of-expertise/lifestyle">
                        Design
                      </Link>
                    </li>
                    <ul>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/lifestyle/crafts">
                          Crafts
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/lifestyle/event-planning">
                          Event Planning
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/lifestyle/fashion-and-beauty">
                          Fashion and Beauty
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/lifestyle/food-and-drink">
                          Food and Drink
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/lifestyle/health-and-wellness">
                          Health and Wellness
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/lifestyle/religion-and-spirituality">
                          Religion and Spirituality
                        </Link>
                      </li>
                    </ul>

                    <li>
                      <Link to="/shadowings/areas-of-expertise/math-and-science">
                        Math and Science
                      </Link>
                    </li>
                    <ul>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/math-and-science/computer-science">
                          Computer Science
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/math-and-science/engineering">
                          Engineering
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/math-and-science/life-science">
                          Life Science
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/math-and-science/mathematics">
                          Mathematics
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/math-and-science/physical-science">
                          Physical Science
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/math-and-science/social-science">
                          Social Science
                        </Link>
                      </li>
                    </ul>

                    <li>
                      <Link to="/shadowings/areas-of-expertise/music">
                        Music
                      </Link>
                    </li>
                    <ul>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/music/audio-engineering">
                          Audio Engineering
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/music/life-performance">
                          Life Performance
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/music/mastering">
                          Mastering
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/music/mixing">
                          Mixing
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/music/music-production">
                          Music Production
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/music/recording">
                          Recording
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/music/sound-design">
                          Sound Design
                        </Link>
                      </li>
                    </ul>

                    <li>
                      <Link to="/shadowings/areas-of-expertise/performing-arts">
                        Performing Arts
                      </Link>
                    </li>
                    <ul>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/performing-arts/comedy">
                          Comedy
                        </Link>
                      </li>

                      <li>
                        <Link to="/shadowings/areas-of-expertise/performing-arts/dance">
                          Dance
                        </Link>
                      </li>

                      <li>
                        <Link to="/shadowings/areas-of-expertise/performing-arts/juggling">
                          Juggling
                        </Link>
                      </li>

                      <li>
                        <Link to="/shadowings/areas-of-expertise/performing-arts/magic">
                          Magic
                        </Link>
                      </li>

                      <li>
                        <Link to="/shadowings/areas-of-expertise/performing-arts/theater">
                          Theater
                        </Link>
                      </li>
                    </ul>

                    <li>
                      <Link to="/shadowings/areas-of-expertise/photography">
                        Photography
                      </Link>
                    </li>
                    <ul>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/photography/aerial-photography">
                          Aerial Photography
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/photography/astrophotography">
                          Astrophotography
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/photography/commercial-photography">
                          Commercial Photography
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/photography/event-photography">
                          Event Photography
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/photography/nature-and-wildlife">
                          Nature and Wildlife
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/photography/photo-editing">
                          Photo Editing
                        </Link>
                      </li>
                    </ul>
                    <li>
                      <Link to="s/hadowings/areas-of-expertise/society">
                        Society
                      </Link>
                    </li>
                    <ul>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/society/education">
                          Education
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/society/environment-and-sustainability">
                          Environment and Sustainability
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/society/government">
                          Government
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/society/law">
                          Law
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/society/nonprofit-organizations">
                          Nonprofit Organizations
                        </Link>
                      </li>
                    </ul>
                    <li>
                      <Link to="/shadowings/areas-of-expertise/sports-and-recreation">
                        Sports and Recreation
                      </Link>
                    </li>
                    <ul>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/sports-and-recreation/adventure-sports">
                          Adventure Sports
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/sports-and-recreation/extreme-sports">
                          Extreme Sports
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/sports-and-recreation/fitness-and-exercise">
                          Fitness and Exercise
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/sports-and-recreation/motor-sports">
                          Motor Sports
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/sports-and-recreation/summer-sports">
                          Summer Sports
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/sports-and-recreation/winter-sports">
                          Winter Sports
                        </Link>
                      </li>
                    </ul>
                    <li>
                      <Link to="/shadowings/areas-of-expertise/technology">
                        Technology
                      </Link>
                    </li>
                    <ul>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/technology/app-development">
                          App Development
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/technology/artificial-intelligence">
                          Artificial Intelligence
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/technology/game-development">
                          Game Development
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/technology/network-and-security">
                          Network and Security
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/technology/robotics">
                          Robotics
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/technology/software-engineering">
                          Software Engineering
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/technology/web-development">
                          Web Development
                        </Link>
                      </li>
                    </ul>
                    <li>
                      <Link to="/shadowings/areas-of-expertise/trade-skills">
                        Trade Skills
                      </Link>
                    </li>
                    <ul>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/trade-skills/automotive">
                          Automotive
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/trade-skills/aviation">
                          Aviation
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/trade-skills/construction">
                          Construction
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/trade-skills/electrical">
                          Electrical
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/trade-skills/home-improvement">
                          Home Improvement
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/trade-skills/manufacturing">
                          Manufacturing
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/trade-skills/mechanical">
                          Mechanical
                        </Link>
                      </li>
                    </ul>
                    <li>
                      <Link to="/shadowings/areas-of-expertise/video">
                        Video
                      </Link>
                    </li>
                    <ul>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/video/animation">
                          Animation
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/video/cgi-modeling">
                          CGI Modeling
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/video/post-production">
                          Post Production
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/video/screenwriting">
                          Screenwriting
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/video/video-editing">
                          Video Editing
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/video/video-production">
                          Video Production
                        </Link>
                      </li>
                      <li>
                        <Link to="/shadowings/areas-of-expertise/video/visual-effects">
                          Visual Effects
                        </Link>
                      </li>
                    </ul>
                  </ul>
                  If you would like to request a category or sub-category, let
                  us know!
                </div>
              }
              question="What can I learn?"
            />

            <Question
              answer={
                <div>
                  Shadower is currently beta-testing in Colorado. Contact us if
                  you’re interested in helping us bring the platform to a
                  different state.
                </div>
              }
              question="Where can I shadow experts?"
            />
          </Panel.Body>
        </Panel>
        <Panel>
          <Panel.Heading>My Profiles</Panel.Heading>
          <Panel.Body>
            <Question
              answer={
                <div>
                  There are two types of profiles on Shadower: user and
                  shadowing.
                  <ul>
                    <li>
                      User profiles:
                      <p>
                        Every registered user has a basic, user profile that
                        contains a short bio, profile photo, a list of their
                        verified information and a contact link. Experts may
                        reference this profile to learn about you after you have
                        booked a shadowing session.
                      </p>
                    </li>
                    <li>
                      Shadowing profiles:
                      <p>
                        In order to let people shadow you, you must create a
                        shadowing profile. A shadowing profile contains all of
                        the information potential shadowers will need to make an
                        informed decision about shadowing you, including
                        examples of your work, shadowing restrictions and a
                        calendar that lists all available shadowing
                        opportunities.
                      </p>
                      <p>
                        If you are knowledgeable in multiple areas, we suggest
                        creating a separate shadowing profile for each expertise
                        (e.g. one profile for music production and another for
                        graphic design).
                      </p>
                    </li>
                  </ul>
                </div>
              }
              question="User versus shadowing profiles"
            />

            <Question
              answer={
                <div>
                  To create a shadowing profile, click on your profile picture
                  in the top right corner and select{' '}
                  <strong>
                    {' '}
                    <FontAwesomeIcon icon={faAddressCard}/>
                    &nbsp; Profiles
                  </strong>
                  . In the navigation menu to the left, click on{' '}
                  <strong>
                    <FontAwesomeIcon icon={faPlusCircle}/> Create a shadowing
                    profile
                  </strong>
                  .
                </div>
              }
              question="How do I add a shadowing profile?"
            />

            <Question
              answer={
                <div>
                  To update your user profile:
                  <ul>
                    <li>
                      Click on your profile picture in top right corner and
                      select{' '}
                      <strong>
                        {' '}
                        <FontAwesomeIcon icon={faAddressCard}/>
                        &nbsp; Profiles
                      </strong>
                      .
                    </li>
                    <li>
                      In the navigation menu to the left, click on your name.
                      Then select{' '}
                      <strong>
                        <FontAwesomeIcon icon={faPencilAlt}/>
                        &nbsp; Edit
                      </strong>{' '}
                      in the top right corner to go into edit mode.
                    </li>
                    <li>
                      Once in edit mode, you can upload a profile photo, tell
                      everyone about you and add your hometown.
                    </li>
                    <li>
                      Click <strong>Save</strong> to update your profile and
                      return to view-only mode.
                    </li>
                  </ul>
                  To update your shadowing profile(s):
                  <ul>
                    <li>
                      Click on your profile picture in top right corner and
                      select{' '}
                      <strong>
                        <FontAwesomeIcon icon={faAddressCard}/>
                        &nbsp; Profiles
                      </strong>
                      .
                    </li>
                    <li>
                      In the navigation menu to the left, click on the shadowing
                      profile. Then select{' '}
                      <strong>
                        {' '}
                        <FontAwesomeIcon icon={faPencilAlt}/>
                        &nbsp; Edit
                      </strong>{' '}
                      in the top right corner to go into edit mode.
                    </li>
                    <li>
                      Once in edit mode, you can add information about shadowing
                      you and fill out a calendar with shadowing opportunities.
                    </li>
                    <li>
                      Click <strong>Save</strong> to update your profile and
                      return to view-only mode.
                    </li>
                  </ul>
                </div>
              }
              question="How do I update my profiles?"
            />

            <Question
              answer={
                <div>
                  <div>Your user profile name</div>
                  <ul>
                    <li>
                      The name on your user profile must be <i>your</i> name.
                    </li>
                  </ul>

                  <div>Media on your profiles</div>
                  <ul>
                    <li>
                      All uploaded media must belong to you or your company or
                      organization. We do not allow stock media or copyrighted
                      content.
                    </li>
                    <li>
                      You must have the proper authorization to upload any
                      supplemental content over which you do not retain
                      copyright.
                    </li>
                  </ul>

                  <div>Information on your profiles</div>
                  <ul>
                    <li>You may not add false or misleading information.</li>
                    <li>
                      You may not use the profile to promote spam or content
                      that is illicit, fraudulent, abusive, disrespectful or
                      harassing in nature.
                    </li>
                  </ul>
                  <p>
                    For additional profile guidelines and restrictions, see the{' '}
                    <Link to="/policies/terms-of-service">
                      Terms of Service
                    </Link>
                    .
                  </p>
                </div>
              }
              question="Profile guidelines"
            />
          </Panel.Body>
        </Panel>
        <Panel>
          <Panel.Heading>My Account</Panel.Heading>
          <Panel.Body>
            {/*  <Question
            question="How do I add or update my credit card on file?"
            answer={
              <div>
                To add or update your credit card information,
                click on your profile picture in the top right
                corner and select{' '}
                <strong>
                  {' '}
                  <FontAwesomeIcon icon={faCog} />
                  &nbsp; Settings
                </strong>
                . Navigate to <strong>  <FontAwesomeIcon icon={faCreditCard} />
                  &nbsp; Payment</strong> to alter, delete or add a credit card.
              </div>
            }
          /> */}
            <Question
              answer={
                <div>
                  To add or update your payout method, click on your profile
                  picture in the top right corner and select{' '}
                  <strong>
                    {' '}
                    <FontAwesomeIcon icon={faCog}/>
                    &nbsp; Settings
                  </strong>
                  . Navigate to{' '}
                  <strong>
                    {' '}
                    <FontAwesomeIcon icon={faDollarSign}/>
                    &nbsp; Payout Methods
                  </strong>{' '}
                  and edit your payout method through Stripe.
                </div>
              }
              question="How do I add or update my payout method?"
            />

            {/*   <Question
            question="How do I update my email address or phone number?"
            answer={
              <div>
                To update your email address, click on your
                profile picture in the top right corner and select{' '}
                <strong>  <FontAwesomeIcon icon={faCog} />
                  &nbsp; Settings</strong>, then navigate to{' '}
                <strong>  <FontAwesomeIcon icon={faUserCircle} />
                  &nbsp; Account</strong>.
              </div>
            }
          /> */}

            <Question
              answer={
                <div>
                  To change your password, click on your profile picture in the
                  top right corner and select{' '}
                  <strong>
                    {' '}
                    <FontAwesomeIcon icon={faCog}/>
                    &nbsp; Settings
                  </strong>
                  , then navigate to{' '}
                  <strong>
                    {' '}
                    <FontAwesomeIcon icon={faLock}/>
                    &nbsp; Security{' '}
                  </strong>
                  .
                </div>
              }
              question="How do I change my password?"
            />

            <Question
              answer={
                <div>
                  To deactivate your account, click on your profile picture in
                  the top right corner and select{' '}
                  <strong>
                    {' '}
                    <FontAwesomeIcon icon={faCog}/>
                    &nbsp; Settings
                  </strong>
                  , then navigate to{' '}
                  <strong>
                    {' '}
                    <FontAwesomeIcon icon={faUserCircle}/>
                    &nbsp; Account
                  </strong>
                  . Click the <strong>Deactivate my account</strong> button and
                  confirm.
                  <br/> <br/>
                  Upon deactivating your account, your login will be disabled,
                  your user profile and shadowing profiles will be hidden from
                  public view, although your data regarding reviews may still be
                  used. Contact us if you want to reactivate your account.
                </div>
              }
              question="How do I deactivate my account?"
            />
            {/* <Question
            question="How do I manage my notification settings?"
            answer={
              <div>
                To update your notification settings, including
                messages, reminders, account support and tool
                tips, click on your profile picture in the top
                right corner and select <strong>  <FontAwesomeIcon icon={faCog} />
                  &nbsp; Settings</strong>.
                Navigate to <strong>  <FontAwesomeIcon icon={faBell} />
                  &nbsp; Notifications</strong> and
                either select or deselect the notification method
                listed. Note: email notifications regarding
                account support cannot be disabled for your
                safety.
              </div>
            }
          /> */}
          </Panel.Body>
        </Panel>
      </React.Fragment>
    );
  }
}

export default TheBasicsSection;
